import { render, staticRenderFns } from "./LeftTextBorder.vue?vue&type=template&id=5c807a12&scoped=true"
import script from "./LeftTextBorder.vue?vue&type=script&lang=js"
export * from "./LeftTextBorder.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBorder.vue?vue&type=style&index=0&id=5c807a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c807a12",
  null
  
)

export default component.exports